import { fireIssueCreateErrorAnalytics as fireErrorAnalytics } from '@atlassian/jira-issue-create-analytics-common/src/utils/fire-error-analytics/index.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { StatusFieldLoad } from '@atlassian/jira-issue-create-analytics/src/services/experiences/index.tsx';
import { transformData, transformDataWithValidations } from './transformer.tsx';

const constructEndpoint = (cloudId: string, expand?: string) => {
	const baseUrl = `/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial`;
	return expand ? `${baseUrl}?expand=${expand}` : baseUrl;
};

const getTransitions = async (
	cloudId: string,
	projectId: string,
	issueTypeId: string,
	expand?: string,
) => {
	const url = constructEndpoint(cloudId, expand);

	StatusFieldLoad.start();

	try {
		const resp = await performPostRequest(url, {
			body: JSON.stringify({
				projectId,
				issueTypeId,
			}),
		});

		StatusFieldLoad.success();
		return expand ? transformDataWithValidations(resp) : transformData(resp);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		StatusFieldLoad.failure();
		fireErrorAnalytics({
			meta: {
				id: 'getTransitions',
				packageName: 'jiraIssueCreate',
				teamName: 'gryffindor',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};

export default getTransitions;
